import React, { Component } from 'react'
import styles from './Hero.module.css'
import appStyles from '../../App.module.css'

class Hero extends Component {
  render() {
    const small = this.props.small ? styles.Small : null
    const image = this.props.image ? (
      <div className={styles.HeroBox}>
        <img
          alt="hero"
          src={this.props.image}
        />
      </div>
    ) : null
    const srcset = this.props.srcset ? (
      <div className={styles.HeroBox}>
        <picture>
          <img
            alt="hero"
            src={this.props.srcset.small}
          />
        </picture>
      </div>
    ) : null
    return (
      <>
        <div className={styles.Hero}>
          <div className={`${styles.HeroImage} ${small}`}>
            {image}
            {srcset}
          </div>
          <div className={`${styles.HeroInfo} ${appStyles.CenterContainer} ${small}`}>
            {this.props.children}
          </div>
        </div>
      </>
    )
  }
}

export default Hero
